











































import Vue from 'vue';
import {
  DECREMENT_EDIT_STEP, SET_EXPERIMENTAL_STDS, INCREMENT_EDIT_STEP,
} from './RedMatCalculationModule';
import LigandAtomDTO from './LigandAtomDTO';

export default Vue.extend({
  name: 'SetExperimentalStds',
  data() {
    return {
      ligandAtoms: [] as LigandAtomDTO[],
      currentValue: '0',
      headers: [
        {
          text: 'Atom Number',
          value: 'atomNumber',
        },
        {
          text: 'Atom Name',
          value: 'atomName',
        },
        {
          text: 'Residue Number',
          value: 'residueNumber',
        },
        {
          text: 'Residue Name',
          value: 'residueName',
        },
        {
          text: 'STD0',
          value: 'std',
        },
      ],
    };
  },
  computed: {
    stdsAreValid() {
      return this.ligandAtoms
        .map((la) => la.std)
        .every((std) => !Number.isNaN(std));
    },
  },
  created() {
    // deep clone ligand atoms from the store
    this.ligandAtoms = JSON.parse(JSON.stringify(this.$store.state.redMatCalculation.ligandAtoms));
  },
  methods: {
    onOpenEditDialog(ligandAtom: LigandAtomDTO) {
      this.currentValue = ligandAtom.std.toString();
    },
    onSaveEditDialog(ligandAtom: LigandAtomDTO) {
      const ligandAtoms = this.ligandAtoms
        .map((la: LigandAtomDTO) => {
          if (la.atomNumber === ligandAtom.atomNumber) {
            return {
              ...ligandAtom,
              std: Number(this.currentValue),
            };
          }

          return la;
        });

      this.ligandAtoms = ligandAtoms;
    },
    onClickPrevious() {
      this.$store.dispatch(DECREMENT_EDIT_STEP);
    },
    onClickNext() {
      this.$store.dispatch(SET_EXPERIMENTAL_STDS, this.ligandAtoms)
        .then(() => {
          this.$store.dispatch(INCREMENT_EDIT_STEP);
        });
    },
  },
});
